import { ROUTE } from '../routingConfig/routeDetails'

const commonLinks = [
  {
    value: 'home', label: 'Home', link: ROUTE.HOME, icon: '0', showDivider: true,
  },
  {
    value: 'pesticide', label: 'Pesticide', link: ROUTE.PESTICIDES, icon: '0', showDivider: false,
  },
  {
    value: 'fertilizer', label: 'Fertilizer', link: ROUTE.FERTILIZER, icon: '0', showDivider: false,
  },
  {
    value: 'seed', label: 'Seed', link: ROUTE.SEED, icon: '0', showDivider: false,
  },
  {
    value: 'animal', label: 'Animal', link: ROUTE.ANIMAL, icon: '0', showDivider: false,
  },
  {
    value: 'dairy', label: 'Dairy', link: ROUTE.DAIRY, icon: '0', showDivider: true,
  },
  {
    value: 'facilities', label: 'Facilities', link: ROUTE.FACILITIES, icon: '0', showDivider: false,
  },
  {
    value: 'seminar', label: 'Seminar', link: ROUTE.SEMINAR, icon: '0', showDivider: false,
  },
  {
    value: 'kcc', label: 'KCC', link: ROUTE.KCC, icon: '0', showDivider: false,
  },
  {
    value: 'advisor', label: 'Advisor', link: ROUTE.ADVISOR, icon: '0', showDivider: false,
  },
  {
    value: 'apply', label: 'Apply', link: ROUTE.APPLY, icon: '0', showDivider: false,
  },
  {
    value: 'contactUs', label: 'Contact Us', link: ROUTE.CONTACTUS, icon: '0', showDivider: true,
  },
]

const publicLinks = [
  {
    value: 'login', label: 'Login', link: ROUTE.LOGIN, icon: '0', showDivider: false,
  },
  {
    value: 'sign-up', label: 'Register', link: ROUTE.SIGNUP, icon: '0', showDivider: true,
  },

]

const privateLinks = [
  {
    value: 'account', label: 'Account', link: ROUTE.ACCOUNT, icon: '0', showDivider: false,
  },
  {
    value: 'logout', label: 'Logout', link: ROUTE.LOGOUT, icon: '0', showDivider: true,
  },
]

const cartLinks = [
  {
    value: 'cart', label: 'Cart', link: ROUTE.CART, icon: '0', showDivider: false,
  },
]

export {
  commonLinks, publicLinks, privateLinks, cartLinks,
}
